import {Delete, GET, POST} from "../util";

const inspectionUrl = "api/team-inspection/trader";
const operationUrl = "api/team-operation/trader";

const url = {
    inspection: {
        listUsers: `${inspectionUrl}/user/list?excludeMasterUser=:excludeMasterUser`,
        userData: `${inspectionUrl}/user/:userId`,
        permissions: `${inspectionUrl}/user/permissions`,
        userPermissions: `${inspectionUrl}/user/permissions/:userId`,
    },
    operation: {
        addUser: `${operationUrl}/user/add`,
        editUser: `${operationUrl}/user/:userId/edit`,
        disableUser: `${operationUrl}/user/:userId/disable`,
        enableUser: `${operationUrl}/user/:userId/enable`,
        deleteUser: `${operationUrl}/user/:userId`,
        handOver: `${operationUrl}/hand-over/:fromUserId/:toUserId`,
        sendUserActivationMail: `${operationUrl}/user/:userId/resend-activation-mail`,
    }
};

const traderTeamManagementApi = {
    inspection: {
        listUsers: (params, excludeMasterUser = false) => {
            return POST(url.inspection.listUsers.replace(":excludeMasterUser", excludeMasterUser), params);
        },
        getUserDetails: (userId) => {
            return GET(url.inspection.userData.replace(":userId", userId));
        },
        getPermissions: (roleIds = null) => {
            return GET(url.inspection.permissions, {
                roleIds: roleIds ? roleIds.join(",") : null
            });
        },
        getUserPermissions: (userId, roleIds = null) => {
            return GET(url.inspection.userPermissions.replace(":userId", userId), {
                roleIds: roleIds ? roleIds.join(",") : null
            });
        },
    },
    operation: {
        addUser: (data) => {
            return POST(url.operation.addUser, data);
        },
        editUser: (userId, data) => {
            return POST(url.operation.editUser.replace(":userId", userId), data);
        },
        disableUser: (userId) => {
            return POST(url.operation.disableUser.replace(":userId", userId));
        },
        enableUser: (userId) => {
            return POST(url.operation.enableUser.replace(":userId", userId));
        },
        deleteUser: (userId) => {
            return Delete(url.operation.deleteUser.replace(":userId", userId));
        },
        handOver: (fromUserId, toUserId) => {
            return POST(url.operation.handOver.replace(":fromUserId", fromUserId).replace(":toUserId", toUserId));
        },
        sendUserActivationMail: (userId) => {
            return POST(url.operation.sendUserActivationMail.replace(":userId", userId));
        }
    }
};
export {
    traderTeamManagementApi
};